<template>
    <div class="CardSelector" ref="CardSelector">
        <template v-for="i in renderItemCount">
            <div
                v-if="i < cardList.length"
                :key="i"
                class="card-type-item"
                :class="{disabled: cardList[i -1].disabled}"
                @click="selectCard(cardList[i -1])"
                draggable="true"
                @dragstart="onDragStart($event, cardList[i -1])"
                @dragend="onDragEnd"
            >
                <div>
                    <div class="centerX">
                        <img :src="'/img/scenario/card/normal/' + cardList[i - 1].type + '.svg'" alt="">
                    </div>
                    <div class="centerX cart-type-name">{{ $f.tc(cardList[i - 1].name) }}</div>
                </div>
            </div>
        </template>
        <v-menu offset-x nudge-left="400" v-if="cardList.length > renderItemCount">
            <template v-slot:activator="{on}">
                <div class="card-type-item" v-on="on">
                    <div>
                        <div class="centerX"><v-icon>mdi-dots-horizontal</v-icon></div>
                        <div class="centerX cart-type-name">{{ $f.tc('more') }}</div>
                    </div>
                </div>
            </template>
            <div class="more-container">
                <div
                    v-for="i in (cardList.length - renderItemCount)"
                    :key="i"
                    class="card-type-item"
                    :class="{disabled: cardList[i + renderItemCount - 1].disabled}"
                    @click="selectCard(cardList[i + renderItemCount - 1])"
                    draggable="true"
                    @dragstart="onDragStart($event, cardList[i + renderItemCount - 1])"
                    @dragend="onDragEnd"
                >
                    <div>
                        <div class="centerX">
                            <img :src="'/img/scenario/card/normal/' + cardList[i + renderItemCount - 1].type + '.svg'" alt="">
                        </div>
                        <div class="centerX cart-type-name">{{ $f.tc(cardList[i + renderItemCount - 1].name) }}</div>
                    </div>
                </div>
            </div>
        </v-menu>
    </div>
</template>

<script>
import { CardType, MapCardTypeToData } from '@/utils/const'
import { mapState } from 'vuex'

const DisabledCardType = [
    CardType.IMAGE,
    CardType.CAROUSEL,
    CardType.FORM,
    CardType.GO_TO_STEP,
    CardType.QUICK_REPLY,
    CardType.JSON_API,
    CardType.ZALO_LIST_TEMPLATE,
    CardType.REQUEST_USER_LOCATION
]

export default {
    name: 'CardSelector',
    data () {
        return {
            itemHeight: 80,
            renderItemCount: 0
        }
    },
    computed: {
        ...mapState({
            cardList: state => {
                let cardConfigList = state.scenario.appConfigList.reduce((array, item) => {
                    if (item.config_key.startsWith('bot_allow') || item.config_key === 'bot_knowledge_base_enable') {
                        if (item.config_value === '1') {
                            array.push(item.config_key)
                        }
                    }
                    return array
                }, [])
                let cardList = []
                for (let i in MapCardTypeToData) {
                    let item = MapCardTypeToData[i]
                    let shouldEnableCard = true
                    if (item.configKey && !cardConfigList.includes(item.configKey)) {
                        shouldEnableCard = false
                    }
                    if (
                        state.scenario.activeStepCode === state.scenario.startSessionStepCode ||
                        state.scenario.activeStepCode === state.scenario.startSentenceStepCode
                    ) {
                        if (DisabledCardType.includes(i)) {
                            shouldEnableCard = false
                        }
                    }
                    if (shouldEnableCard) {
                        cardList.push({
                            type: i,
                            disabled: false,
                            ...MapCardTypeToData[i]
                        })
                    }
                }
                return cardList
            }
        })
    },
    mounted () {
        this.onWindowResize()
        window.addEventListener('resize', this.onWindowResize)
    },
    destroyed () {
        window.removeEventListener('resize', this.onWindowResize)
    },
    methods: {
        onWindowResize () {
            let container = this.$refs.CardSelector
            this.renderItemCount = Math.floor(container.getBoundingClientRect().height / this.itemHeight) - 1
            if (this.renderItemCount < 0) {
                this.renderItemCount = 0
            }
        },
        selectCard (data) {
            this.$emit('select', {
                card_type_id: data.type
            })
        },
        onDragStart (event, card) {
            event.dataTransfer.setData('addCardType', card.type)
            this.$store.commit(this.$at.scenario.DRAGGING_CARD, true)
        },
        onDragEnd () {
            this.$store.commit(this.$at.scenario.DRAGGING_CARD, false)
        }
    }
}
</script>

<style scoped lang="scss">
.more-container {
    background: #fff;
    display: flex;
    flex-wrap: wrap;
    width: 320px;

    .card-type-item {
        border-right: 1px solid #F2F4FA;
    }
}

.card-type-item {
    width: 80px;
    height: 80px;
    border-bottom: 1px solid #F2F4FA;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    cursor: pointer;

    &:hover {
        background: #F2F4FA;
    }

    &.disabled {
        opacity: 0.5;
    }

    .cart-type-name {
        font-size: 0.8em;
        text-align: center;
    }
}
</style>
